// Mint-ActionLog · Nhật ký thao tác: dữ liệu mẫu theo script board (TblUserActionLog), chưa ghi / đọc DB.

export const CATS = ['AUTH', 'NAV', 'JOB', 'SI', 'SERVICE', 'EMAIL', 'PRINT', 'ADMIN'] as const;
export type Cat = (typeof CATS)[number];
export type Tone = 'ok' | 'warn' | 'err' | 'pri' | 'mute';
export const CAT_TONE: Record<Cat, Tone> = { AUTH: 'ok', NAV: 'pri', JOB: 'pri', SI: 'warn', SERVICE: 'err', EMAIL: 'pri', PRINT: 'mute', ADMIN: 'warn' };
export const CAT_VI: Record<Cat, string> = { AUTH: 'Đăng nhập', NAV: 'Điều hướng', JOB: 'Job', SI: 'SI / B/L', SERVICE: 'Dịch vụ', EMAIL: 'Email', PRINT: 'In / PDF', ADMIN: 'Quản trị' };
export const USERS = ['DAVID', 'ThuyNTT', 'MAITTN', 'PHONGNT', 'THANHTTK', 'HANHLTM', 'TUANNT', 'NGOCNTB', 'PhuongHT', 'LIENNTK'] as const;
export const DEVS = ['Desktop · Chrome', 'Desktop · Edge', 'iPad · Safari', 'Phone · HANA Ezy', 'App tài xế'] as const;
export type Range = 'today' | 'week' | 'month';
export const RANGES: readonly (readonly [Range, string])[] = [['today', 'Hôm nay'], ['week', '7 ngày'], ['month', '30 ngày']];
export const TOTAL: Record<Range, number> = { today: 412, week: 2418, month: 9860 };

type Act = readonly [string, string];
const ACTS: Record<Cat, readonly Act[]> = {
  AUTH: [['Đăng nhập', 'M365 SSO · MFA đạt'], ['Đăng xuất', 'hết phiên 8 giờ'], ['Khoá màn', 'tự khoá sau 15 phút']],
  NAV: [['Mở danh sách Job', 'lọc BK Standby'], ['Mở Booking', 'SE260636900'], ['Mở Công nợ', 'tab Tuổi nợ']],
  JOB: [['Đổi trạng thái job', 'SE260636900 {"from":"BK Standby","to":"BK Confirmed","BookingNo":"SGNGCP779500"}'], ['Tạo job', 'SE260639540 {"Customer":"MKSF","POD":"CNNSA"}'], ['Gộp lô', 'SE260635080 {"merge":"SE260634330"}']],
  SI: [['Lưu SI', 'SE260635440 {"HBL":"HNSGN260635440","TypeBLIssue":"HBL"}'], ['Gửi SI cho hãng', 'SE260622020 {"Carrier":"EGLV"}']],
  SERVICE: [['Gán xe TRF', 'TRF2610077 {"VehicleID":"13970","Driver":"KHAINH"}'], ['Finish chuyến', 'TRF2610071 {"Ref":"SE260609170"}']],
  EMAIL: [['Gửi Booking Confirm', 'SE260622020 → NAMMY'], ['Gửi Arrival Notice', 'RE260676830 → MKSF']],
  PRINT: [['In B/L nháp', 'HNSGN260622020 · PrintKit'], ['Xuất PDF Debit Note', 'DN26054408']],
  ADMIN: [['Đặt lại mật khẩu M365', 'PHUONGNKT · gửi quản lý trực tiếp'], ['Xem như người khác', 'TUANNT · chỉ đọc'], ['Sửa ô database', 'customer.MST · C-0133 {"reason":"khách gửi MST mới"}']],
};
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const p2 = (n: number) => `0${n}`.slice(-2);

export interface LogRow { id: string; day: number; hour: number; when: string; user: string; cat: Cat; act: string; detail: string; dev: string }

function build(): LogRow[] {
  const out: LogRow[] = [];
  let ts = Date.UTC(2026, 9, 23, 8, 58);
  for (let i = 0; i < 60; i++) {
    const cat = CATS[(i * 5 + (i >> 2)) % 8]!;
    const a = ACTS[cat][i % ACTS[cat].length]!;
    const user = cat === 'ADMIN' ? 'DAVID' : cat === 'SERVICE' ? (i % 2 ? 'THANHTTK' : 'PHONGNT') : USERS[(i * 3) % 10]!;
    const dev = cat === 'SERVICE' ? (i % 3 ? 'App tài xế' : 'iPad · Safari') : DEVS[(i * 7) % 4]!;
    const d = new Date(ts);
    const h = d.getUTCHours();
    out.push({ id: `AL${i}`, day: d.getUTCDate(), hour: h, when: `${p2(d.getUTCDate())}/${MON[d.getUTCMonth()]}/${d.getUTCFullYear()} ${p2(h)}:${p2(d.getUTCMinutes())}`, user, cat, act: a[0], detail: a[1], dev });
    ts -= (17 + ((i * 13) % 50)) * 60000;
    if (new Date(ts).getUTCHours() < 7) ts -= 13 * 3600000;
  }
  return out;
}
export const ROWS: readonly LogRow[] = build();

export interface Filter { user: string[]; cat: string[]; dev: string[]; hour: string[] }
export const NO_FILTER: Filter = { user: [], cat: [], dev: [], hour: [] };
export const inRange = (r: LogRow, range: Range) => range === 'month' || (range === 'today' ? r.day === 23 : r.day >= 17);
export function matches(r: LogRow, f: Filter): boolean {
  return (!f.user.length || f.user.includes(r.user)) && (!f.cat.length || f.cat.includes(r.cat)) && (!f.dev.length || f.dev.includes(r.dev)) && (!f.hour.length || f.hour.includes(r.hour < 12 ? 'Sáng' : 'Chiều'));
}
/** Dòng trong khoảng ngày + khớp ô tìm (chưa áp bộ lọc). */
export function baseRows(range: Range, q: string): LogRow[] {
  const qq = q.trim().toLowerCase();
  return ROWS.filter((r) => inRange(r, range) && (!qq || [r.user, r.cat, r.act, r.detail, r.dev].join(' ').toLowerCase().includes(qq)));
}
export const countBy = <K extends 'user' | 'cat' | 'dev'>(rows: readonly LogRow[], key: K, vals: readonly string[]): [string, number][] => vals.map((v) => [v, rows.filter((r) => r[key] === v).length]);
export const initials = (u: string) => u.replace(/[^A-Za-z]/g, '').slice(0, 2).toUpperCase();
